module.exports = {"TXTWCL_Total_spinsX_N0":{"id":"TXTWCL_Total_spinsX_N0","defaultMessage":"Nombre total de tours : {0}"}}